import {
  formatPhoneNumber,
  formatEINNumber,
  isAValidEmail,
  isAValidUSPhoneNumber,
  isAValidEINNumber,
} from '../../../utils';

import { legalFirmInfo, accountingFirmInfo } from '../../../utils/globals';

const userInfoFormContent = [
  {
    name: 'firstName',
    label: 'First Name',
    type: 'text',
  },
  {
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
  },
  {
    name: 'email',
    label: 'Email',
    type: 'email',
    isGiven: true,
    formatChecker: isAValidEmail,
    helperText: 'Invalid email format',
  },
  {
    name: 'phoneNumber',
    label: 'Phone number',
    type: 'tel',
    formatChecker: isAValidUSPhoneNumber,
    helperText: 'Invalid US Phone number format',
    formatter: formatPhoneNumber,
  },
];

const companyInfoFormContent = [
  {
    label: 'Company name',
    name: 'companyName',
    type: 'text',
    className: 'formSection2',
  },
  {
    label: 'DBA',
    name: 'dba',
    type: 'text',
    className: 'formSection3',
    isOptional: true,
  },
  {
    label: 'Company street address',
    name: 'companyStreetAddress',
    type: 'text',
    className: 'formSection4',
  },
  {
    label: 'City',
    name: 'city',
    type: 'text',
    className: 'formSection5',
  },
  {
    label: 'State',
    name: 'state',
    className: 'formSection6',
    type: 'text',
  },
  {
    label: 'Zip code',
    name: 'zipCode',
    type: 'text',
    className: 'formSection7',
    helperText: ' ',
  },
  {
    label: 'Country',
    name: 'country',
    type: 'text',
    className: 'formSection8',
  },
  {
    label: 'EIN',
    name: 'ein',
    type: 'text',
    formatChecker: isAValidEINNumber,
    helperText: 'Invalid EIN format',
    formatter: formatEINNumber,
    className: 'formSection9',
    isOptional: true,
  },
  {
    label: 'Company website',
    name: 'companyWebsite',
    type: 'text',
    className: 'formSection10',
    isOptional: true,
  },
];

const extraUserFormContent = [
  {
    name: 'firstName',
    label: 'First Name',
    type: 'text',
  },
  {
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
  },
  {
    name: 'email',
    label: 'Email',
    type: 'email',
    formatChecker: isAValidEmail,
    helperText: 'Invalid e-mail format',
  },
  {
    name: 'accountPermission',
    label: 'Account permissions',
    isSelect: true,
    menuItems: [{
      label: 'View',
      value: 'view',
    },
    {
      label: 'Edit',
      value: 'edit',
    },
    {
      label: 'Admin',
      value: 'admin',
    }],
  },
];

const legalFirmInfoFormContent = [
  {
    label: 'Name of firm',
    name: 'legalFirmName',
    isAutocomplete: true,
    options: legalFirmInfo,
    isOptional: true,
  },
  {
    label: 'Name of advisor (your point of contact)',
    name: 'legalAdvisorName',
    type: 'text',
    isOptional: true,
  },
  {
    label: 'Advisor email',
    name: 'legalAdvisorEmail',
    type: 'email',
    formatChecker: isAValidEmail,
    helperText: 'Invalid e-mail format',
    isOptional: true,
  },
  {
    label: 'Their permissions on your account',
    name: 'legalAdvisorPermission',
    // TODO Remove line when needed after amvp
    className: 'hidden-for-mvp',
    isSelect: true,
    isOptional: true,
    menuItems: [{
      label: 'View',
      value: 'view',
    },
    {
      label: 'Edit',
      value: 'edit',
    },
    {
      label: 'Admin',
      value: 'admin',
    }],
  },
];

const accountingFirmInfoFormContent = [
  {
    label: 'Name of firm',
    name: 'accountingFirmName',
    isAutocomplete: true,
    options: accountingFirmInfo,
    isOptional: true,
  },
  {
    label: 'Name of advisor (your point of contact)',
    name: 'accountingAdvisorName',
    type: 'text',
    isOptional: true,
  },
  {
    label: 'Advisor email',
    name: 'accountingAdvisorEmail',
    type: 'email',
    isOptional: true,
    formatChecker: isAValidEmail,
    helperText: 'Invalid e-mail format',
  },
  {
    label: 'Their permissions on your account',
    name: 'accountingAdvisorPermission',
    // TODO Remove line when needed after amvp
    className: 'hidden-for-mvp',
    isSelect: true,
    isOptional: true,
    menuItems: [{
      label: 'View',
      value: 'view',
    },
    {
      label: 'Edit',
      value: 'edit',
    },
    {
      label: 'Admin',
      value: 'admin',
    }],
  },
];

function assignDefaultValues(formContent) {
  let defaultValues = {};
  formContent.forEach((data) => {
    defaultValues = { ...defaultValues, [data.name]: '' };
  });
  if (formContent === companyInfoFormContent) {
    defaultValues = { ...defaultValues, extraUsers: [] };
  }
  return defaultValues;
}

const userInfoDefaultValues = assignDefaultValues(userInfoFormContent);
const companyInfoDefaultValues = assignDefaultValues(companyInfoFormContent);
const legalFirmInfoDefaultValues = assignDefaultValues(legalFirmInfoFormContent);
const accountingFirmInfoDefaultValues = assignDefaultValues(accountingFirmInfoFormContent);
const extraUserDefaultValues = assignDefaultValues(extraUserFormContent);

const allFormsContent = [
  ...userInfoFormContent,
  ...companyInfoFormContent,
  ...legalFirmInfoFormContent,
  ...accountingFirmInfoFormContent,
  ...extraUserFormContent,
];

const errorDefaultValues = {
  ...userInfoDefaultValues,
  ...companyInfoDefaultValues,
  ...legalFirmInfoDefaultValues,
  ...accountingFirmInfoDefaultValues,
};
Object.keys(errorDefaultValues).forEach((value) => {
  if (!Array.isArray(errorDefaultValues[value])) {
    errorDefaultValues[value] = false;
  }
});

const hasErrorDefaultValues = errorDefaultValues;

export {
  allFormsContent,
  userInfoFormContent,
  companyInfoFormContent,
  legalFirmInfoFormContent,
  accountingFirmInfoFormContent,
  extraUserFormContent,
  userInfoDefaultValues,
  companyInfoDefaultValues,
  legalFirmInfoDefaultValues,
  accountingFirmInfoDefaultValues,
  extraUserDefaultValues,
  hasErrorDefaultValues,
};
